<template>
  <div class="branches_table grey loading_table">
    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
    <b-table
      default-sort="name"
      ref="table"
      pagination-simple
      per-page="15"
      :data="branchesList"
      paginated
      checkable
      @page-change="changePage"
      @sort="initSort"
      backend-sorting
      backend-pagination
      :total="totalCount"
      detailed
      :show-detail-icon="false"
      @click="openInfo"
    >
      <template slot-scope="props">
        <b-table-column label="Название" :visible="true" field="name" :centered="false" sortable width="15%">
          <div>{{ props.row.name }}</div>
        </b-table-column>
        <b-table-column label="Дата создания" :visible="true" field="created_at" :centered="true" sortable width="30%">
          <div>{{ props.row.created_at | moment('DD.MM.YYYY') }}</div>
        </b-table-column>
        <b-table-column label="Сотрудники" :visible="true" field="users_count" :centered="true" sortable width="15%">
          <div>{{ props.row.users_count }}</div>
        </b-table-column>
        <b-table-column label="Адрес" :visible="true" field="address" :centered="true" sortable width="40%">
          <div>{{ props.row.address }}</div>
        </b-table-column>
      </template>

      <template slot="detail" slot-scope="props">
        <div class="table_actions">
          <button class="delete_course" @click="$emit('delete-branch', props.row.id)" v-if="!props.row.deleted_at">
            <i class="mdi mdi-folder-remove-outline"></i> В архив
          </button>
          <button class="restore_course" @click="$emit('restore', props.row.id)" v-else>
            <i class="mdi mdi-folder-remove-outline"></i> Восстановить
          </button>
          <button class="double_course" v-if="!props.row.deleted_at" @click="openBranchEdit(props.row)">
            <router-link :to="'/branches/' + props.row.id">
              <i class="mdi mdi-folder-open-outline"></i> Редактировать/смотреть филиал
            </router-link>
          </button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    branchesList: {
      default: () => [],
      type: Array
    },
    rows: {
      default: () => {},
      type: Object
    },
    totalCount: {
      default: () => 0,
      type: Number
    },
    isLoading: {
      default: () => true,
      type: Boolean
    }
  },
  data() {
    return {
      openedRow: {}
    }
  },
  methods: {
    initSort(fieldName, sortType) {
      this.$emit('init-sort', fieldName, sortType)
    },
    openInfo(row) {
      if (row != this.openedRow) {
        this.$refs.table.toggleDetails(this.openedRow)
        this.$refs.table.toggleDetails(row)
        this.openedRow = row
        return
      }
      this.$refs.table.toggleDetails(row)
      this.openedRow = {}
    },
    changePage(val) {
      this.$emit('changePage', val)
    },
    openBranchEdit(val) {
      if (this.$browserDetect.isIE) {
        this.$router.push('/branches/' + val.id)
      }
    }
  }
}
</script>
